import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import tooltip from "./tooltip.js"
import Label from "./Label.js";


const template = `
    <div :id="'container_range_'+iuid" v-show="fs.display(input)">

        <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>
        <span v-if="input.type != 'hidden' && input.show_value" :id="input.id+'_slider_value_announcer'" class="sr-only" aria-live="polite" aria-atomic="true" >{{slider_value}}</span>



        <div v-if="!input.range_type || input.range_type == 1" class="input-range">
            <div class="grid collapse">
                <div :class="input.left_class" >     
                    <qt-label :iuid="iuid" v-if="!isTruthy(input.hidden)"></qt-label>
                    <small v-for="detail in input.options[input.value].details">{{detail}}</small>
                </div>
                <div :class="input.right_class + ' range-slider_wrapper'" role="group" :aria-label="'This slider contains '+(computed_max+1)+' options.' " >
                    <transition name="fade" mode="out-in" >
                        <span v-show="input.show_value" class="slider-value" :data-uid="input.uid+'_sldr_val'" :style="calcThumbPos(lengthThumbPosition)"  >{{slider_value}}</span>
                    </transition>
                    <span class="slider-bar" :style="{ width: lengthThumbPosition + '%' }"></span>
                    <input v-bind="input.validation" @mouseover="showValueTooltip" @mouseleave="hideValueTooltip(input.tooltip_active_duration)" @input="change();exec($event, input)" @change="change();exec($event, input)" @click="change();exec($event, input)" type="range" :id="input.uid" class="range-slider" :data-uid="input.uid" :min="computed_min" :step="computed_steps" :max="computed_max" :value="input.value" :aria-labelledby="'label_'+input.uid">
                </div>
            </div>
        </div>

       <div v-if="input.range_type == 2" class="input-range-2 grid">
            <div  :class="input.left_class ? input.left_class : 's12 clm'" >     
                <qt-label :iuid="iuid" v-if="!isTruthy(input.hidden)"></qt-label>
                <small v-for="detail in input.options[input.value].details">{{detail}}</small>
            </div>
            <div :class="input.right_class ? input.right_class + ' range-slider_wrapper' : 's12 clm range-slider_wrapper'" role="group" :aria-label="'This slider contains '+(computed_max+1)+' options.' ">
                <transition name="fade" mode="out-in" >
                    <span v-show="input.show_value" class="slider-value" :data-uid="input.uid+'_sldr_val'" :style="calcThumbPos(lengthThumbPosition)"   >{{slider_value}}</span>
                </transition>
                <span aria-live="polite" aria-atomic="true" class="slider-bar" :style="{ width: lengthThumbPosition + '%' }"></span>                
                <input v-bind="input.validation" @mouseover="showValueTooltip" @mouseleave="hideValueTooltip(input.tooltip_active_duration)" @input="change();exec($event, input)" @change="change();exec($event, input)" @click="change();exec($event, input)" type="range" :id="input.uid" class="range-slider" :data-uid="input.uid" :min="computed_min" :step="computed_steps" :max="computed_max" :value="input.value" :aria-labelledby="'label_'+input.uid">
            </div>
        </div>

        <div v-if="input.range_type == 3" class="input-range-3" :class="input.card_range ? 'card' : ''">
            <div class="grid collapse">
                <div  :class="input.left_class" >     
                    <qt-label :iuid="iuid" v-if="!isTruthy(input.hidden)"></qt-label><br />
                    <small>{{ formatDisplayValue( input.value ) }}</small>
                </div>
                <div :class="input.right_class + ' range-slider_wrapper'" role="group" :aria-label="'This slider contains '+(computed_max+1)+' options.' " >
                    <transition name="fade" mode="out-in" >
                        <span v-show="input.show_value" class="slider-value" :data-uid="input.uid+'_sldr_val'" :style="calcThumbPos(lengthThumbPosAlt)"   >{{ formatDisplayValue( input.value ) }}</span>
                    </transition>
                    <span class="slider-bar" :style="{ width: lengthThumbPosAlt + '%' }"></span>
                    <input v-bind="input.validation" @mouseover="showValueTooltip" @mouseleave="hideValueTooltip(input.tooltip_active_duration)" @input="change();exec($event, input)" @change="change();exec($event, input)" @click="change();exec($event, input)" type="range" :id="input.uid" class="range-slider" :data-uid="input.uid" :min="input.min" :step="input.step" :max="input.max" :value="input.value" :aria-labelledby="'label_'+input.uid">
                </div>
            </div>
        </div>

        <div v-if="input.range_type == 4" class="input-range-4">
            <div class="grid collapse">
                <div  :class="input.left_class ? input.left_class : 's12 clm'" >     
                    <qt-label :iuid="iuid" v-if="!isTruthy(input.hidden)"></qt-label><br />
                    <small v-for="detail in input.available_options[input.value].details">{{detail}}</small>
                </div>
                <div :class="input.right_class ? input.right_class: 's12 clm ' + ' range-slider_wrapper'" role="group" :aria-label="'This slider contains '+(computed_max+1)+' options.' "  >
                    <transition name="fade" mode="out-in" >
                        <span v-show="input.show_value" class="slider-value" :data-uid="input.uid+'_sldr_val'" :style="calcThumbPos(lengthThumbPosition)"  >{{ input.available_options[input.value].details[0] }}</span>
                    </transition>
                    <span class="slider-bar" :style="{ width: lengthThumbPosition + '%' }"></span>
                    <input v-bind="input.validation" @mouseover="showValueTooltip" @mouseleave="hideValueTooltip(input.tooltip_active_duration)" @input="changeAlt();exec($event, input)" @change="changeAlt();exec($event, input)" @click="changeAlt();exec($event, input)" type="range" :id="input.uid" class="range-slider" :data-uid="input.uid" :min="computed_min" :step="computed_steps" :max="computed_max" :value="input.value" :aria-labelledby="'label_'+input.uid">
                </div>
            </div>
        </div>

        <div v-if="input.range_type == 5" class="input-range-5" :class="input.card_range ? 'card' : ''">
            <div class="grid ">
                <div class="s12 clm" >
                    <qt-label :iuid="iuid" v-if="!isTruthy(input.hidden)"></qt-label>
                </div>
            </div>
            <div class="grid collapse">
                <div  :class="input.left_class" >
                    <span class="h4">{{ showDualElemLabel('element_two') }} </span>
                    <small>{{ formatDisplayValue( 100 - input.value ) }}</small>
                    
                </div>
                <div  :class="input.left_class" >
                    <span class="h4">{{ showDualElemLabel('element_one') }} </span>
                    <small>{{ formatDisplayValue( input.value ) }}</small>
                </div>
                <div class="s12 clm" role="group" :aria-label="'This slider contains '+(input.max+1)+' options.' " >
                    <transition name="fade" mode="out-in" >
                        <span v-show="input.show_value" class="slider-value" :data-uid="input.uid+'_sldr_val'" :style="calcThumbPos(lengthThumbPosAlt)"   >{{ formatDisplayValue( input.value ) + ' - ' + formatDisplayValue( 100 - input.value ) }}</span>
                    </transition>
                    <span class="slider-bar" :style="{ width: lengthThumbPosAlt + '%' }"></span>
                    <input v-bind="input.validation" @mouseleave="hideValueTooltip(input.tooltip_active_duration)" @input="changeDual();exec($event, input)" @change="changeDual();exec($event, input)" @click="changeDual();exec($event, input)" type="range" :id="input.uid" class="range-slider" :data-uid="input.uid" :min="input.min" :step="input.step" :max="input.max" :value="input.value">
                </div>
            </div>
        </div>

    </div>
`;

export default {
    name: 'b-input-range',
    template,
    components: {
        'b-tooltip': tooltip,
        'qt-label': Label
    },
    props: ['iuid'],
    mixins: [Mixin],
    watch: {
        "input.loading": function (newVal, oldVal) {
           this.fs.elementAnnouncer(this.input)
        }
    },
    created: function(){
        if(this.input.options.length > 0){
            const fs = new Funnel({ ctx: this.$store, router: this.$router });
            this.input.available_options = []

            let icount = 0

            for(const indx in this.input.options){
                if(fs.display(this.input.options[indx])){ // only checks on load. on-page dynamic updates not available
                    this.input.available_options[icount] = this.input.options[indx]

                    if(
                        !Utils.isEmpty(this.input.hidden_element) &&
                        !Utils.isEmpty(fs.ctx.getters.funnel.elements[this.input.hidden_element].value) &&
                        this.$store.getters.funnel.elements[this.input.hidden_element].value == this.input.options[indx].value
                    ){
                        this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: icount });
                    }

                    icount++
                }
            }
        }
    },
    mounted: function(){
        if(!this.input.value){
            console.log(this.input.uid+' value not set on the element json. set the value to be the same as min')

            if (!Utils.isEmpty(this.input.hidden_element)) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.hidden_element, key: 'value', val: this.input.available_options[this.input.value].value });
            }else{
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.input.min });
            }
        }
    },
    computed: {
        
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        tipeTwo: function(){
            return this.input.range_type == 2 || this.input.range_type == 4
        },
        isCustom: function(){
            return (this.input.available_options != null && this.input.available_options.length > 0) || ( this.input.coverage != null && this.input.coverage.options.length > 0)
        },
        lengthThumbPosition: function() {
            if (this.tipeTwo) {
                var value = ((this.input.value ) / (this.computed_max ) * 100)
            }
            else{
                var value = ((this.input.value ) / (this.computed_max ) * 100)
            }

            return value;
        },
        lengthThumbPosAlt: function(){

            let input_value = parseInt(this.input.value)

            let offset_value = (this.input.step - this.input.min) // add additional step if min is less than step

            let total_positions = (offset_value + (this.input.max - this.input.step)) / this.input.step
            let current_position = ((offset_value + input_value) /  this.input.step) - 1

            return (current_position  / total_positions ) * 100
        },
        stepScale: function(){
            return (this.input.step / this.input.max) + 50
        },
        validationRules () {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computed_min: function(){
            return this.input.min
        },
        computed_max: function(){
            if (this.isCustom) {
                //disregard max and use the length of the custom options
                if (this.tipeTwo) {
                    return (this.input.available_options.length -1 )
                }else{
                    return (this.input.available_options.length -1 )
                }

            }
            else{
                return this.input.step
            }

        },
        slider_value: function(){
            if (this.isCustom) {
                if (this.input.uid.includes('in_coverage_collision_vehicle') || this.input.uid.includes('in_coverage_comprehensive_vehicle')) {
                    return this.input.available_options[this.input.value].details[0].replace('$', '');
                } else if (this.input.uid.includes('in_towing')) {
                    return this.input.available_options[this.input.value].label;
                } else {
                    return this.input.available_options[this.input.value].value;
                }
            } else {
                return this.input.value;
            }
        },
        computed_steps: function(){

            return this.input.step
        },
        computedMask: function(){
            return this.input.validation.mask
        },

    },
    methods: {
        calcThumbPos: function(length){
            let thumbPos = length 
            return { left: 'calc(' + thumbPos + '%)' }
        },
        change: function(){
            this.showValueTooltip();
        },
        showValueTooltip: function(){
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'show_value', val: true });
        },
        hideValueTooltip: function(active_time){
            var self = this
            setTimeout(function(){
                self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'show_value', val: false });
            },active_time)

        },
        changeAlt: function(){
            this.showValueTooltip();
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.hidden_element, key: 'value', val: this.input.available_options[this.input.value].value });
        },
        changeDual: function(){
            this.showValueTooltip();
            const valOne = parseInt(this.input.value)
            const valTwo = 100 - parseInt(this.input.value)

            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.element_one, key: 'value', val: valOne });
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.element_two, key: 'value', val: valTwo });
        },
        formatDisplayValue: function(value){
            if(!Utils.isEmpty(this.input.format)) {
                let formattedValue = parseInt(value)

                if (!Utils.isEmpty(this.input.format.commas) && this.input.format.commas) {
                    formattedValue = formattedValue.toLocaleString("en-US")
                }

                if (!Utils.isEmpty(this.input.format.currency) && this.input.format.currency) {
                    formattedValue = '$' + formattedValue
                }

                if (!Utils.isEmpty(this.input.format.percentage) && this.input.format.percentage) {
                    formattedValue = formattedValue + '%'
                }
                return formattedValue
            }
            else {
                return value
            }
        },
        showDualElemLabel: function(elemName){
            let label = '';

            const getOptionLabel = (val) => {
                for(const option of this.$store.getters.funnel.elements[this.input.dual_elements].options){
                    if(option.value == val){
                        return option.label;
                    }
                }
            }

            switch(elemName){
                case 'element_one':
                    label = getOptionLabel(this.$store.getters.funnel.elements[this.input.dual_elements].value[0])
                    break;
                case 'element_two':
                    label = getOptionLabel(this.$store.getters.funnel.elements[this.input.dual_elements].value[1])
                    break;
            }

            return label
        },
        updateDualElemValues: function(){

        }
    }
};